import { useEffect } from "react";
import { useSelector } from "react-redux";

const CommonTheme = () => {
  const restaurantDetails = useSelector(
    (state: any) => state.restaurant.currentRestaurantDetail
  );

  useEffect(() => {
    const primaryColor = restaurantDetails?.theme?.primaryColor || "#618432"; // returns green if undefined
    const secondoryColor = restaurantDetails?.theme?.secondaryCode || "white"
    const textColor = restaurantDetails?.theme?.textColor || "black";
    const linearColor = `linear-gradient(to right, ${primaryColor}, ${secondoryColor})`;
    document.documentElement.style.setProperty("--primary-color", secondoryColor);
    document.documentElement.style.setProperty("--secondary-color", primaryColor);
    document.documentElement.style.setProperty("--text-color", textColor);
    document.documentElement.style.setProperty("--linear-color", linearColor);
  }, [restaurantDetails?.theme]);

  return null;
};

export default CommonTheme;